import { useEffect, useRef, useState } from "react";
import { ChangeAlertCallbackType, ChangeLoaderCallbackType } from "../../../Root";
import { LeadService } from "../../../../services/LeadService";
import { constitutiveAct } from "../../../../util/DataObject";
import moment from "moment";
moment.locale("es");

export const useCompanyRecord = (changeAlert: ChangeAlertCallbackType, changeLoader: ChangeLoaderCallbackType, onClose: Function) => {
    const [data, setData] = useState([]);
    const [zPos, setZPos] = useState(45);

    const leadService = useRef<LeadService>();

    const onHandelGetAct = async (leadUuid: string) => {
        changeLoader(true);
        setZPos(-1);

        const resp = await leadService.current.getCompanyRecord({
            lead_uuid: leadUuid,
        });
        
        if (resp?.data?.response === "OK") {
            let result = resp.data.content;
            let newData = [];

            if(result["status"] === "success"){
                newData = constitutiveAct.map((item) => {
                    const fieldData = result.data[item.key] || null;
                    const verdict = result.comparison_verdict.find((v) => v.field === item.key) || {};
    
                    return {
                        key: item.key,
                        label: item.label,
                        type: item.type,
                        value: fieldData?.value || null,
                        pages: fieldData?.pages || null,
                        status: verdict.status || "unknown",
                        reason: verdict.reason || null,
                        priority: verdict.priority_level || null,
                        extraData: fieldData,
                    };
                });
            }

            setData(newData);
            setZPos(45);
        } else {
            changeAlert(true, "error", resp["data"]["message"] || resp.message);
            onClose();
        }
        changeLoader(false);
    };

    useEffect(() => {
        leadService.current = new LeadService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { onHandelGetAct, data, zPos };
};
